















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { DetalleFactura } from '@/pantallas/Facturacion/fetchFacturaciones';

@Component({
  components: {},
})
export default class FacturaTable extends Vue {
  @Prop() facturaSeleccionada: DetalleFactura;
}
